import { Component, Injector, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PinnedScenariosComponent } from 'src/app/modules/pricing/components/pinned-scenarios/pinned-scenarios.component';
import { PricingScenario } from 'src/app/modules/pricing/models/pricing/pricing-scenario.model';
import { ProductSearchRequestInfo } from 'src/app/modules/pricing/models/pricing/product-search-request-info.model';
import { PricingService } from 'src/app/modules/pricing/services/pricing.service';
import { ApplicationContextService } from 'src/app/services/application-context.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ApplicationContextBoundComponent } from 'src/app/shared/components';

@Component({
    selector: 'tpo-quick-pricer',
    templateUrl: 'tpo-quick-pricer.component.html',
    standalone: false
})
export class TpoQuickPricerComponent extends ApplicationContextBoundComponent implements OnDestroy {

  productSearchRequestInfo: ProductSearchRequestInfo = new ProductSearchRequestInfo();

  @ViewChild("pinnedScenarios")
  pinnedScenariosComponent: PinnedScenariosComponent;

  isTpo: boolean = false;

  isScenariosSectionOpen: boolean = false;

  scenarios: PricingScenario[] = [];

  atLeastOneScenarioIsRefreshing: boolean = false;
  branchZip: string = undefined;

  protected requestLockEnabled: boolean = false;

  private readonly _contextSubscription: Subscription;

  constructor(private readonly injector: Injector,
    private readonly _pricingService: PricingService,
    private readonly _applicationContextService: ApplicationContextService,
    private readonly _notifyService: NotificationService,
    private readonly _navigationService: NavigationService) {

    super(injector);
    this._contextSubscription = this._applicationContextService.context.subscribe(context => {
      this.isTpo = context.isTpo;
      this.requestLockEnabled = this.isTpo && (context.isCompanyLodasoft || context.isCompanyPRMG);
      this.branchZip = context.userPermissions.branchIds?.length > 0 ? context.globalConfig.branches.find(x => x.branchId == context.userPermissions.branchIds[0])?.zip : undefined;
    });
  }

  async ngOnInit() {
    const pricingEnabled = this.applicationContext.userPermissions.pricingEnabled;
    if (!pricingEnabled) {
      this._navigationService.navigateToPath('tpo/dashboard');
      this._notifyService.showError('You do not have permission to access Quick Pricer', 'Access Denied');
      return;
    }

    if (this.applicationContext.isCompanyPRMG) {
      const ppeChannels = this.applicationContext.userPermissions.ppeLoanChannels;
      if (!ppeChannels || ppeChannels.length === 0) {
        this._navigationService.navigateToPath('tpo/dashboard');
        this._notifyService.showError('You do not have permission to access Quick Pricer', 'Access Denied');
        return;
      }
    }

    if (this.applicationContext.isCompanySmartfi) {
      this._navigationService.navigateToPath('tpo/new-application');
      return;
    }
    this.productSearchRequestInfo = await this._pricingService.getDefaultPricingRequest(this.branchZip);
    this.getScenarios();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._contextSubscription?.unsubscribe();
  }

  private getScenarios = () => {
    this._pricingService.getPricingScenariosGlobal().subscribe({
      next: (scenarios) => {
        this.scenarios = scenarios;
      },
      error: (err) => {
        this._notifyService.showError(err.message || err, "Error!");
      }
    });
  }
}
